import { render, staticRenderFns } from "./MessageSectionChooser.vue?vue&type=template&id=331f23bf"
import script from "./MessageSectionChooser.vue?vue&type=script&lang=js"
export * from "./MessageSectionChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports